import { Component, ComponentType, ErrorInfo, ReactNode } from 'react'

type ErrorHandler = (error: Error, info: ErrorInfo) => void
type ErrorHandlingComponent<Props> = (props: Props, error?: Error) => ReactNode
type ErrorState = { error?: Error }

export default function Catch<Props extends {}>(
  component: ErrorHandlingComponent<Props>,
  errorHandler?: ErrorHandler,
): ComponentType<Props> {
  return class extends Component<Props, ErrorState> {
    static getDerivedStateFromError(error: Error) {
      return { error }
    }

    constructor(props) {
      super(props)
      this.state = {
        error: undefined,
      }
    }

    // eslint-disable-next-line class-methods-use-this
    componentDidCatch(error: Error, info: ErrorInfo) {
      if (errorHandler) {
        errorHandler(error, info)
      }
    }

    render() {
      const { error } = this.state

      return component(this.props, error)
    }
  }
}
